import type { QueryClient } from "@tanstack/react-query";

// Removing or restoring an activity changes every activity-derived view: the
// heatmap trace goes or returns (geom lives on the row), stats/achievements
// are recomputed server-side, and the map caches must not keep serving a
// removed line. Explored cells and coverage are monotonic and unaffected, but
// the "map" keys are cheap to refetch so they are included rather than
// reasoned about per key. Shared by the Activities page and the Connected
// sources import panel (spec 26).
export function invalidateAfterActivityChange(queryClient: QueryClient) {
  for (const queryKey of [
    ["activities"],
    ["activities/removed"],
    ["activities/import-preferences"],
    ["profile/stats"],
    ["profile/activity-heatmap"],
    ["integrations"],
    ["map/heatmap"],
    ["map/features"],
    ["map"],
    ["heatmap"],
    ["collections"],
    ["achievements"],
    // Trips sum their live members, and restoring a planned-route GPX clears
    // its trip's route (specs 35 and 38).
    ["trips"],
  ]) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
